
import { Vue } from "vue-class-component";

export default class ClipboardCheck extends Vue {}
